// extracted by mini-css-extract-plugin
module.exports = {"root":"MaterialSelector_root__ziQ0w","select":"MaterialSelector_select__4iGTD"};